/*************************************************/
/* CARDS                                         */
/*************************************************/

export function cards() {
    const imageContainerSelector = ".subpage-cards__scale-max-height--image-container";

    const init = function () {

        document.addEventListener("lazyloaded", function (e) {
            if ($(e.target).closest(imageContainerSelector).length) {
            $(imageContainerSelector).matchHeight();
        }

    });
};

init();
}



// WEBPACK FOOTER //
// ./src/scripts/partials/cards.js